import { render, staticRenderFns } from "./riskFactorItemPop.vue?vue&type=template&id=72e148c2"
import script from "./riskFactorItemPop.vue?vue&type=script&lang=js"
export * from "./riskFactorItemPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72e148c2')) {
      api.createRecord('72e148c2', component.options)
    } else {
      api.reload('72e148c2', component.options)
    }
    module.hot.accept("./riskFactorItemPop.vue?vue&type=template&id=72e148c2", function () {
      api.rerender('72e148c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/rft/riskFactorItemPop.vue"
export default component.exports